import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Challenge } from '@/app/core/models/p-place/pixel';

@Pipe({
	name: 'challengeRewards',
	standalone: true
})
export class ChallengeRewardsPipe implements PipeTransform {

	constructor(private translate: TranslateService) {}

	transform(challenge: Challenge): string {
		if (!challenge || !challenge.rewards?.length) return '';

		const lang = this.translate.currentLang || 'fr';
		const parts: string[] = [];

		for (const reward of challenge.rewards) {
			if (reward.type === 'BADGE') {
				// Nom du badge dépend du type de challenge
				const goal = challenge.goal;
				if (lang === 'fr') {
					parts.push(`<span class="text-yellow-400 drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">un badge spécial</span>`);
				} else {
					const unit = challenge.type === 'PIXEL' ? 'pixels' : 'connections';
					parts.push(`<span class="text-peps-gold drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">a special badge</span>`);
				}
			} else {
				// Récompense en pixels
				if (lang === 'fr') {
					parts.push(`<span class="text-yellow-400 drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">${reward.value} pixels</span>`);
				} else {
					parts.push(`<span class="text-yellow-400 drop-shadow-[0_0_4px_rgba(238,201,50,0.7)]">${reward.value} pixels</span>`);
				}
			}
		}

		// Concatène les parties avec "et" / "and"
		const joinWord = lang === 'fr' ? ' et ' : ' and ';
		const rewardsText = parts.join(joinWord);

		// Préfixe selon la langue
		return lang === 'fr'
			? `Reçoit ${rewardsText}`
			: `Receives ${rewardsText}`;
	}
}
